import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon.tsx";

const NonBankCardContents = ({ active }) => {
  const { ranking } = useStaticQuery(graphql`
    query NonBankCardContents {
      ranking: mysqlRanking(mysqlId: {eq: 127}) {
        url
        prefix_url
      }
    }
  `);

  if (!ranking) {
    return null;
  }

  return (<>
    <strong>Rankingi</strong>

    <Link 
      to={resolveUrl(ranking.prefix_url, ranking.url)} 
      className={["top-navigation-link", "gold", b.mt2, b.mb4].join(' ')}
    >
      {active && <span className="top-navigation-link-icon">
        <Icon icon="Ranking" size={34} />
      </span>}
      
      Ranking pozabankowych kart kredytowych
    </Link>
  </>);
};

export default NonBankCardContents;
